import { z } from "zod";
import type { BoardDisplayChange } from "@design-system/Board/Board.types";
import type { BoardCollapsed } from "@components/views/board/boardLayoutCache";
import { TASK_BOARD_SORTS, type TaskBoardSortState } from "./taskBoardSort";
import {
    taskBoardLaneBySchema,
    type TaskViewBoardDisplay,
} from "./taskBoardViewDisplay";

/**
 * What the board shows: the view's swimlanes and empty columns, the user's
 * collapsed columns and lanes, the order List and Board share, and the card
 * fields, which are List's visible columns as `TaskColumn` ids.
 */
export type TaskBoardDisplayState = TaskViewBoardDisplay &
    BoardCollapsed &
    TaskBoardSortState & { cardFields: string[] };

const displayChangeSchema = z
    .object({
        groupBy: taskBoardLaneBySchema,
        isEmptyColumnsShown: z.boolean(),
        sort: z.enum(TASK_BOARD_SORTS),
        sortDirection: z.enum(["asc", "desc"]),
    })
    .partial();

/** A Display popover change: swimlanes, empty columns or order. */
export type TaskBoardDisplayChange = z.infer<typeof displayChangeSchema>;

/**
 * The settings a Display popover change carries, narrowed to the board's
 * own; a change naming an unknown swimlane or sort is dropped.
 */
export const parseTaskBoardDisplayChange = (
    change: BoardDisplayChange,
): TaskBoardDisplayChange => {
    const parsed = displayChangeSchema.safeParse(change);
    return parsed.success ? parsed.data : {};
};
